import { useBanners } from 'components/GlobalBanners/globalBanners';
import { useEffect } from 'react';
import { usePSLabs } from '../../controllers/contexts/labsFeatures';
import { Requests } from '../../controllers/network';
import { PS_PAY } from '../admin/utils/feature-flags';

const OnboardingStatusBanner = () => {
  const {
    location: { pathname: path },
  } = window;

  const { addBanner, removeBanner } = useBanners();
  const { hasLabsFlag } = usePSLabs();

  const updateStatusAndBanner = async () => {
    const { action_message: actionMessage, action_url: actionUrl } =
      await Requests.get('/v2/pspay/shop/status');

    if (actionMessage && !path.includes('/pspay-customer')) {
      addBanner({
        id: 'pspay-setup',
        isDismissable: true,
        data: {
          variant: 'warning',
          heading: 'Complete Text-to-Buy setup',
          bodyText: actionMessage,
          primaryAction: {
            text: 'Update on Shopify',
            onClick: () => {
              removeBanner('pspay-setup');
              window.location.replace(actionUrl);
            },
          },
        },
      });
    }
  };

  useEffect(() => {
    updateStatusAndBanner();
  }, [hasLabsFlag(PS_PAY)]);

  return null;
};

export default OnboardingStatusBanner;
